import React from 'react';

function StoringPromptsContent() {
  return (
    <>
      <p>RepoPrompt's stored prompts feature allows you to save and reuse system prompts to guide the AI's role and output format.</p>
      
      <h3>Understanding Stored Prompts</h3>
      <p>Stored prompts in RepoPrompt are reusable system messages that:</p>
      <ul>
        <li>Provide consistent instructions to the AI across different sessions</li>
        <li>Define specific AI roles (like the built in "Architect" or "Engineer")</li>
        <li>Structure the AI's output format for better consistency</li>
        <li>Can be combined with your specific instructions</li>
      </ul>
      
      <h3>Using Stored Prompts</h3>
      <ol>
        <li>Active stored prompts appear above the instructions text box. </li>
        <li>Hover over a prompt tab to preview its content</li>
        <li>Active prompts will be prepended to your instructions in the "Meta prompts" section when generating the final prompt</li>
      </ol>
      
      <h3>Managing Stored Prompts</h3>
      <ol>
        <li>Click the "Prompts" button on the far right of the prompt tab bar</li>
        <li>A dropdown list appears with available prompts</li>
        <li>Clicking on a prompt will toggle it</li>
        <li>Use the "Create New" or "Edit" options to manage your prompt library</li>
        <li>You can import and export stored prompts from the advanced settings menu, using a bespoke json format.</li>
      </ol>
      
      <h3>Creating Custom Prompts</h3>
      <p>To create a new stored prompt:</p>
      <ol>
        <li>Click the "Prompts" button and select "Create New"</li>
        <li>Enter a name for your prompt (e.g., "Code Reviewer")</li>
        <li>Write the prompt content in the editor</li>
        <li>Save your new prompt to make it available in the prompts list</li>
      </ol>
      
      <div className="tip-box">
        <strong>Tip:</strong> Create specialized prompts for different tasks, such as code review, architecture planning, bug fixing, or feature implementation to maintain consistency across similar AI interactions.
      </div>
    </>
  );
}

export default StoringPromptsContent;